<template>
  <section>
    <left-menu />
    <modal-disapproved :dataModal="dataModal" />
    <modal-point-vaucher :data-modal="dataCodeVaucher" :idDay="this.pointId"/>
    <modal-solicitation :load-data="loadDataModal"/>

    <button-back :btnRoute="routeBack"/>


    <div id="mainContent" class="detail-point">
      <loading-page v-if="loadingRequest" />

      <div v-else class="row">

        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{dataInfo.date | strDayFull}}, {{dataInfo.date | formatDate}}</h1>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-turn">
            <p v-if="dataInfo.dayStatus !== 5 && dataInfo.dayStatus !== 3 && dataInfo.dayStatus !== 4" class="certa title">Turno em aberto</p>

<!--            <div class="old-progress-bar">-->
<!--              <div class="pending-hours">-->
<!--                <p v-bind:class="{'color-red': dataInfo.dayStatus === 5, 'color-black': dataInfo.dayStatus === 4, 'color-black': dataInfo.dayStatus === 3}" class="nunito"><span>Horas trabalhadas</span></p>-->

<!--                <p v-bind:class="{'color-red': dataInfo.dayStatus === 5, 'color-black': dataInfo.dayStatus === 4, 'color-black': dataInfo.dayStatus === 3}" class="certa">-->
<!--                  {{dataInfo.worked}}-->
<!--                </p>-->
<!--              </div>-->

<!--              <div class="progress-new-2">-->
<!--                <div class="line-progress">-->
<!--                  <div v-bind:style="{'width': progressPercent <= 100 ? progressPercent + '%' : '100%'}"></div>-->
<!--                </div>-->

<!--                <div class="content-hours">-->
<!--                    <span title="Total Trabalhado">-->
<!--                      <span>{{dataInfo.worked}}</span>-->
<!--                    </span>-->
<!--                  <span title="Total Necessário">-->
<!--                      <span>{{dataInfo.needWork}}</span>-->
<!--                    </span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

            <div class="new-progress-bar-detail">
              <div class="circle">
                <div id="maskFull" class="mask full">
                  <div id="firstFill" class="fill" v-bind:class="{'background-bue': dataInfo.dayStatus === 1, 'background-green': dataInfo.dayStatus === 3, 'background-yellow': dataInfo.dayStatus === 4}"></div>
                </div>
                <div class="mask half">
                  <div id="secondFill" class="fill" v-bind:class="{'background-bue': dataInfo.dayStatus === 1, 'background-green': dataInfo.dayStatus === 3, 'background-yellow': dataInfo.dayStatus === 4}"></div>
                </div>
                <div class="inside-circle">
                  <p>
                    <span class="nunito" v-bind:class="{'color-red': dataInfo.dayStatus === 5}">Horas trabalhadas</span>
                    <span class="certa" v-bind:class="{'color-red': dataInfo.dayStatus === 5, 'color-black': dataInfo.dayStatus === 4, 'color-black': dataInfo.dayStatus === 3}">{{dataInfo.worked}}<span class="nunito"></span></span>
                  </p>
                </div>
              </div>
            </div>

<!--            <a v-if="dataInfo.dayStatus !== 5 && dataInfo.dayStatus !== 3 && dataInfo.dayStatus !== 4" href="/registro-de-ponto" class="certa register-point">-->
<!--              <span class="certa">-->
<!--                <img src="/src/assets/img/icons/hand-blue.png" class="img-responsive" alt="ícone"/>-->
<!--                Marcar ponto-->
<!--              </span>-->
<!--            </a>-->

            <div class="adj">
              <p v-if="dataInfo.adjustmentStatus === 1" class="nunito pn-adj">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path class="b" d="M22.7,19,13.6,9.9A6.418,6.418,0,0,0,12.1,3,6.611,6.611,0,0,0,4.7,1.7L9,6,6,9,1.6,4.7a6.445,6.445,0,0,0,1.3,7.4,6.418,6.418,0,0,0,6.9,1.5l9.1,9.1a.967.967,0,0,0,1.4,0l2.3-2.3a.9.9,0,0,0,.1-1.4Z"/>
                </svg>
                <span>Ajuste pendente</span>
              </p>

              <p v-if="dataInfo.adjustmentStatus === 2" class="nunito accept-adj">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path class="b" d="M22.7,19,13.6,9.9A6.418,6.418,0,0,0,12.1,3,6.611,6.611,0,0,0,4.7,1.7L9,6,6,9,1.6,4.7a6.445,6.445,0,0,0,1.3,7.4,6.418,6.418,0,0,0,6.9,1.5l9.1,9.1a.967.967,0,0,0,1.4,0l2.3-2.3a.9.9,0,0,0,.1-1.4Z"/>
                </svg>
                <span>Ajuste aceito</span>
              </p>

              <p v-if="!loadingMotive && dataInfo.adjustmentStatus === 3" class="nunito rj-adj">
                <a v-on:click="openMotive()" v-tooltip.top-center="'Clique para saber o motivo da recusa.'">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path class="b" d="M22.7,19,13.6,9.9A6.418,6.418,0,0,0,12.1,3,6.611,6.611,0,0,0,4.7,1.7L9,6,6,9,1.6,4.7a6.445,6.445,0,0,0,1.3,7.4,6.418,6.418,0,0,0,6.9,1.5l9.1,9.1a.967.967,0,0,0,1.4,0l2.3-2.3a.9.9,0,0,0,.1-1.4Z"/>
                  </svg>
                  <span>Ajuste recusado</span>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </a>
              </p>
                <div v-if="loadingMotive" class="loader-mini-box-red">
                  <div class="spinner-box">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
            </div>

            <div v-if="dataInfo.dayStatus === 5 || dataInfo.dayStatus === 3 || dataInfo.dayStatus === 4" class="btns">
              <button v-if="dataInfo.adjustmentStatus !== 1" class="btn-adj nunito" v-on:click="openModalSolicitation()">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path class="a" d="M2.01,21,23,12,2.01,3,2,10l15,2L2,14Z"/>
                </svg>
                <span>Solicitar ajuste/abono</span>
              </button>
              <button v-on:click="sendReceipt()" class="btn-send-c nunito">
                <div class="group-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path class="a" d="M2.01,21,23,12,2.01,3,2,10l15,2L2,14Z"/>
                  </svg>
                  <span>Enviar comprovante</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-point-day">
            <p class="certa title">Registros do dia</p>
            <div v-if="dataInfo.listPoint.length" class="limit-h custom-scrollbar limit-history">
              <div v-if="dataInfo.workShiftType === 4">
                <div v-for="p in dataInfo.listPoint"  class="list-point">
                  <p class="nunito">
                  <span>
                      <span v-if="p.pointRegisterType === 1">Entrada:</span>
                      <span v-if="p.pointRegisterType === 2">Saída intervalo:</span>
                      <span v-if="p.pointRegisterType === 3">Volta intervalo:</span>
                      <span v-if="p.pointRegisterType === 4">Saída:</span>
                  </span>
                    <span class="span">{{p.date}}
                    <i v-if="p.device === 4" title="Sistema" class="fa fa-cog" aria-hidden="true"></i>
                    <i v-if="p.device === 3" title="MarQWeb" class="fa fa-desktop" aria-hidden="true"></i>
                    <i v-if="p.device === 5" title="APP MarQTab" class="fa fa-tablet" aria-hidden="true"></i>
                    <i v-if="p.device === 7" title="Reconhecimento Facial" class="fa fa-smile-o" aria-hidden="true"></i>
                    <i v-if="p.device === 8 || p.device === 9" title="QR Code" class="fa fa-qrcode" aria-hidden="true"></i>
                    <i v-if="p.device === 8 || p.device === 1" title="App Android" class="fa fa-android" aria-hidden="true"></i>
                    <i v-if="p.device === 2 || p.device === 9" title="App IOS" class="fa fa-apple" aria-hidden="true"></i>
                  </span>
                  </p>
                </div>
              </div>
              <div v-else>
                <div v-for="p in dataInfo.listPoint"  class="list-point">
                  <p class="nunito">
                  <span>
                      <span v-if="p.type === 1">Entrada:</span>
                      <span v-else>Saída:</span>
                  </span>
                    <span class="span">{{p.date}}
                    <i v-if="p.device === 4" title="Sistema" class="fa fa-cog" aria-hidden="true"></i>
                    <i v-if="p.device === 3" title="MarQWeb" class="fa fa-desktop" aria-hidden="true"></i>
                    <i v-if="p.device === 5" title="APP MarQTab" class="fa fa-tablet" aria-hidden="true"></i>
                    <i v-if="p.device === 7" title="Reconhecimento Facial" class="fa fa-smile-o" aria-hidden="true"></i>
                    <i v-if="p.device === 8 || p.device === 9" title="QR Code" class="fa fa-qrcode" aria-hidden="true"></i>
                    <i v-if="p.device === 8 || p.device === 1" title="App Android" class="fa fa-android" aria-hidden="true"></i>
                    <i v-if="p.device === 2 || p.device === 9" title="App IOS" class="fa fa-apple" aria-hidden="true"></i>
                  </span>
                  </p>
                </div>
              </div>
            </div>
            <button v-if="dataInfo.listPoint.length" @click="openModalVaucher()" class="vaucher-btn" :disabled="loadingVaucher">
              <div v-if="loadingVaucher" class="loading-btn">
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5">
                  </div>
                </div>
              </div>
              <div v-else class="vaucher-point">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 18.3333L3.75 17.0833L5 18.3333L6.25 17.0833L7.5 18.3333L8.75 17.0833L10 18.3333L11.25 17.0833L12.5 18.3333L13.75 17.0833L15 18.3333L16.25 17.0833L17.5 18.3333V1.66663L16.25 2.91663L15 1.66663L13.75 2.91663L12.5 1.66663L11.25 2.91663L10 1.66663L8.75 2.91663L7.5 1.66663L6.25 2.91663L5 1.66663L3.75 2.91663L2.5 1.66663V18.3333ZM15 7.49996H5V5.83329H15V7.49996ZM15 10.8333H5V9.16662H15V10.8333ZM15 14.1666H5V12.5H15V14.1666Z" fill="#352DA5"/>
                </svg>
                <span v-if="downloadVaucher">Baixar comprovante</span>
                <span v-else>Ver comprovante</span>
              </div>
            </button>
            <div v-if="!dataInfo.listPoint.length" class="empty-list-point">
              <p class="nunito">Não há registros de ponto neste dia.</p>
            </div>
          </div>

          <div v-if="needException && dataInfo.hasSporadic" class="offset-top-10 col-xs-12 col-sm-12 col-md-12 default-box box-exception">
            <span class="box-exception-title">Motivo ponto por exceção:</span>
            <span class="box-exception-motive">{{ dataInfo.sporadic}}</span>
          </div>

          <div v-if="dataPause.pauses.length" class="col-xs-12 col-sm-12 col-md-12 offset-top-30 default-box box-pause-day">
            <p class="certa title">Histórico de pausa do dia</p>
            <div v-if="dataPause.pauses.length" class="limit-h custom-scrollbar">
              <div v-for="(p, index) in dataPause.pauses" class="list-point">
                <p class="nunito">Motivo da pausa: <span>{{p.pauseMotive}}</span></p>
                <p v-if="p.enteredIn" class="nunito">Horário de inicio da pausa: <span>{{p.enteredIn  | formatHours}}h</span></p>
                <p v-if="p.exitIn" class="nunito">Horário de retorno da pausa: <span>{{p.exitIn | formatHours}}h</span></p>

                <span class="nunito icon-date">
                  <img src="../../../../assets/img/icons/calendar-grey.png" class="img-fluid" height="19" width="19"/>
<!--                  {{p.enteredIn | formatDate}}-->
                  </span>
                <span v-if="p.count === 1" class="nunito badge">Em Pausa</span>
                <span v-else class="badge-success nunito">{{p.totalInPause}}</span>
              </div>
            </div>
            <div v-if="!dataPause.pauses.length" class="empty-list-point">
              <p class="nunito">Não há registros de pausa neste dia.</p>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-4">

          <div v-if="$route.params.menus.isManager && !dataInfo.hasJustify">
            <div v-if="dataInfo.hasJustify" class="col-xs-12 col-sm-12 col-md-12 default-box box-justify-he box-justified offset-top-30">
              <div v-if="dataInfo.hasJustify && !dataInfo.justify">
                <span style="color: var(--yellowColor)"><i class="fa fa-exclamation-triangle" aria-hidden="true" style="margin-right: 2%;"/> Justificativa HE</span>
                <p>Não justificado até o momento.</p>
              </div>
              <div v-else>
                <span style="color: var(--yellowColor)"><i class="fa fa-exclamation-triangle" aria-hidden="true" style="margin-right: 2%;"/> Justificativa HE</span>
                <p>{{ dataInfo.justify || '-' }}</p>
              </div>
            </div>
          </div>

          <div v-else>
            <div v-if="dataInfo.hasJustify" class="col-xs-12 col-sm-12 col-md-12 default-box box-justify-he offset-top-30">
              <div v-if="dataInfo.justify == ''" style="margin-top: 12px;">
                <span class="title-justify" style="color: var(--yellowColor)"><i class="fa fa-exclamation-triangle" aria-hidden="true" style="margin-right: 2%;"/> Justificar H.E</span>
                <b v-if="!showJustify" @click="showJustify = true">Clique aqui para justificar as horas excedentes</b>
                <textarea v-if="showJustify" v-model="contentJustify"></textarea>
                <span v-if="validateContentJustify" class="validate-justify">Preencha uma justificativa *</span>
                <button v-if="showJustify" @click="justifyHe()">
                  <span v-if="!loadingJustify">Enviar</span>
                  <div v-else class="loading-btn">
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </button>
              </div>
              <div v-else class="justified-he">
                <span style="margin-top: 6px; color: var(--yellowColor);"><i class="fa fa-exclamation-triangle" aria-hidden="true" style="margin-right: 2%;"/> Justificativa H.E</span>
                <p>{{ dataInfo.justify }}</p>
              </div>
            </div>
          </div>

          <div v-if="dataInfo.dayStatus === 3" class="col-xs-12 col-sm-12 col-md-12 default-box box-success offset-top-30">
            <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>
            <p class="title certa"> Nenhuma ocorrência.</p>
          </div>

          <div v-if="dataInfo.dayStatus === 4" class="col-xs-12 col-sm-12 col-md-12 default-box box-ac offset-top-30">
            <p class="title certa"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Ocorrência</p>
            <p class="text nunito">O número de pontos batidos neste dia está incorreto. Solicite um <a v-bind:href="'/solicitar-ajuste/' + pointId + '/' + + $route.params.type">ajuste</a> para corrigir.</p>
          </div>

          <div v-if="dataInfo.dayStatus === 5" class="col-xs-12 col-sm-12 col-md-12 default-box box-fault offset-top-30">
            <p class="title certa"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Falta</p>
            <p class="text nunito">Você não marcou ponto neste dia. Se você trabalhou, solicite <a v-bind:href="'/solicitar-ajuste/' + pointId + '/' + + $route.params.type">ajuste</a> ou <a v-bind:href="'/solicitar-ajuste/' + pointId + '/' + + $route.params.type">abono</a> para corrigir.</p>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-turn-info offset-top-30">
            <p class="certa title">Turno</p>
            <div class="infos">
              <p class="nunito">Tipo: <span>{{dataInfo.workShiftName}}</span></p>
              <p class="nunito">Horas Necessárias: <span>{{dataInfo.needWork}}</span></p>
              <p class="nunito">Horas Trabalhadas: <span>{{dataInfo.worked}}</span></p>
              <p class="nunito" v-if="dataInfo.hasSporadic">Horas Abonadas: <span>{{dataInfo.totalPaidHours.slice(0, -3)}}</span></p>
              <p v-if="dataInfo.isExtraTime" class="nunito color-green">Horas Extras: <span>{{dataInfo.extraTime}}</span></p>
              <p v-if="dataInfo.isMissingHour" class="nunito color-red">Horas Faltantes: <span>{{dataInfo.missingTime}}</span></p>
            </div>
          </div>

          <div v-if="dataInfo.dayStatus !== 5 && dataInfo.dayStatus !== 3 && dataInfo.dayStatus !== 4" class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
            <img src="/src/assets/img/dayInfo/ImagemCasal.png" class="img-responsive" alt="Default">
          </div>
        </div>
      </div>
    </div>

    <confirmation-modal
      v-if="isModalErrorOpened && !loadingVaucher"
      :title="'Comprovante do dia'"
      :titleIcon="['receipt-outline']"
      :canClose="true"
      @close-modal="v => this.isModalErrorOpened = v"
      id="voucher-modal"
    >
      <div class="voucher-modal-body">

        <div class="voucher-header">
          <span>Seu comprovante</span>
          <span>Está em processamento!</span>
        </div>

        <div class="body-content">
            <ion-icon name="hourglass-outline"></ion-icon>


            <span>Tente visualizar</span>
            <span>novamente mais tarde...</span>

          <div class="footer-body">
            <svg width="327" height="16" viewBox="0 0 327 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.5" d="M8.86445 16L-4.34089e-06 1.29135e-06L17.7289 2.86102e-06L8.86445 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M27.0858 16L17.7289 1.21428e-06L36.4428 2.86102e-06L27.0858 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M45.7997 16L36.4428 1.21428e-06L55.1566 2.86102e-06L45.7997 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M64.5136 16L55.1566 1.21428e-06L73.8705 2.86102e-06L64.5136 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M82.7349 16L73.8705 1.30095e-06L91.5994 2.86102e-06L82.7349 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M100.464 16L91.5994 1.30095e-06L109.328 2.86102e-06L100.464 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M118.193 16L109.328 1.29135e-06L127.057 2.86102e-06L118.193 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M135.922 16L127.057 1.29135e-06L144.786 2.86102e-06L135.922 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M154.143 16L144.786 1.21428e-06L163.5 2.86102e-06L154.143 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M172.857 16L163.5 1.21428e-06L182.214 2.86102e-06L172.857 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M191.078 16L182.214 1.30095e-06L199.943 2.86102e-06L191.078 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M208.807 16L199.943 1.30095e-06L217.672 2.86102e-06L208.807 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M226.536 16L217.672 1.30095e-06L235.401 2.86102e-06L226.536 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M244.265 16L235.401 1.30095e-06L253.13 2.86102e-06L244.265 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M262.486 16L253.13 1.21428e-06L271.843 2.86102e-06L262.486 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M281.2 16L271.843 1.21428e-06L290.557 2.86102e-06L281.2 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M299.914 16L290.557 1.21428e-06L309.271 2.86102e-06L299.914 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M318.136 16L309.271 1.30095e-06L327 2.86102e-06L318.136 16Z" fill="#FFE268"/>
              <path opacity="0.5" d="M9.13591 16L0.27145 1.30095e-06L18.0004 2.86102e-06L9.13591 16Z" fill="#FFE268"/>
            </svg>
          </div>
      </div>
      </div>

      <!-- <div v-if="sendEmailDisplay" class="body-email">
        <div class="email-input">
          <label>
            Enviar para o e-mail <span>*</span>
          </label>
          <input v-model="valueEmail" type="text" placeholder="Digite o seu E-mail">
          <span v-if="validateInputEmail" class="validate-input">
            Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.
          </span>
        </div>
        <div class="email-btn">
          <span @click="statusEmail(false)" class="btn-cancel">Cancelar</span>
          <button @click="sendEmail()" class="btn-send" :disabled="loadingEmail">
            <div v-if="loadingEmail" class="loading-btn">
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5">
                </div>
              </div>
            </div>
            <div v-else class="btn-group">
              Enviar
            </div>
          </button>
        </div>
      </div> -->

      <!-- <button v-else @click="statusEmail(true)">
        <ion-icon name="mail-outline"></ion-icon>
        Enviar por e-mail
      </button> -->

      <button @click="closeModal">
        Fechar
      </button>
    </confirmation-modal>

    <confirmation-modal
      v-if="isVoucherModalOpened && !loadingVaucher"
      :title="'Comprovante do dia'"
      :titleIcon="['receipt-outline']"
      :canClose="true"
      @close-modal="v => this.isVoucherModalOpened = v"
      id="voucher-modal"
    >
      <div class="voucher-modal-body">
        <div class="voucher-header">
          {{ dataCodeVaucher.header }}
          <span class="header-date">
            {{ dataInfo.date | formatDate }}
          </span>
          <span>{{ dataCodeVaucher.employer.name }}</span>
          <span><p>CNPJ:</p> {{ dataCodeVaucher.employer.document | cpfOrCnpj }}</span>
          <span><p>Endereço:</p> {{ dataCodeVaucher.employer.address }}</span>
          <span v-if="dataCodeVaucher.data && dataCodeVaucher.data.inpiRegister"><p>Registro INPI:</p> {{ dataCodeVaucher.data.inpiRegister }}</span>
          <span><p>NSR: </p> {{ dataCodeVaucher.nsr }}</span>
        </div>

        <div class="body-content">
          <div v-for="data, index in dataCodeVaucher.punchs" v-bind:key="index" class="content-points">
            <div class="point-title">Ponto {{index+1}}: <span>{{ data | formatDate }} às {{ data | formatHours}}</span></div>
            <!-- <span>Local: {{ data.data.local }}</span> -->

            <!-- <span class="point-code" :style="data.viewMore ? 'display: block;' : 'display: flex;'">Código: <span :class="!data.viewMore ? 'hide-code' : ''">{{ data.asignHashPoint}}</span>
              <span v-if="data.viewMore" class="more-less" @click="viewMoreLess(data)">Ver menos</span>
              <span v-else class="more-less" @click="viewMoreLess(data)">Ver Mais</span>
            </span> -->
          </div>
        </div>
        <div class="body-collaborator">
          <span class="collaborator-name">Colaborador: <span>{{ dataCodeVaucher.employee.name }}</span></span>
          <span>({{ dataCodeVaucher.employee.document }})</span>
        </div>
        <div class="body-signature">
          <span class="signature-title">Assinatura eletrônica:</span>
          <span class="signature-id" :style="!viewMoreSign ? 'display: flex;' : 'display: block;'">
            <span>{{ dataCodeVaucher.hash }}</span>
            <!-- <span class="more-less" @click="viewMoreLessSign(!viewMoreSign)">{{ viewMoreSign ? 'Ver Menos' : 'Ver Mais' }}</span> -->
          </span>
          <!-- <span class="signature-reference">Referência: <span>{{ dataCodeVaucher.employee.reference }}</span></span> -->
        </div>
        <div class="footer-body">
          <svg width="327" height="16" viewBox="0 0 327 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.5" d="M8.86445 16L-4.34089e-06 1.29135e-06L17.7289 2.86102e-06L8.86445 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M27.0858 16L17.7289 1.21428e-06L36.4428 2.86102e-06L27.0858 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M45.7997 16L36.4428 1.21428e-06L55.1566 2.86102e-06L45.7997 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M64.5136 16L55.1566 1.21428e-06L73.8705 2.86102e-06L64.5136 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M82.7349 16L73.8705 1.30095e-06L91.5994 2.86102e-06L82.7349 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M100.464 16L91.5994 1.30095e-06L109.328 2.86102e-06L100.464 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M118.193 16L109.328 1.29135e-06L127.057 2.86102e-06L118.193 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M135.922 16L127.057 1.29135e-06L144.786 2.86102e-06L135.922 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M154.143 16L144.786 1.21428e-06L163.5 2.86102e-06L154.143 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M172.857 16L163.5 1.21428e-06L182.214 2.86102e-06L172.857 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M191.078 16L182.214 1.30095e-06L199.943 2.86102e-06L191.078 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M208.807 16L199.943 1.30095e-06L217.672 2.86102e-06L208.807 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M226.536 16L217.672 1.30095e-06L235.401 2.86102e-06L226.536 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M244.265 16L235.401 1.30095e-06L253.13 2.86102e-06L244.265 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M262.486 16L253.13 1.21428e-06L271.843 2.86102e-06L262.486 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M281.2 16L271.843 1.21428e-06L290.557 2.86102e-06L281.2 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M299.914 16L290.557 1.21428e-06L309.271 2.86102e-06L299.914 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M318.136 16L309.271 1.30095e-06L327 2.86102e-06L318.136 16Z" fill="#FFE268"/>
            <path opacity="0.5" d="M9.13591 16L0.27145 1.30095e-06L18.0004 2.86102e-06L9.13591 16Z" fill="#FFE268"/>
          </svg>
        </div>
      </div>

      <!-- <div v-if="sendEmailDisplay" class="body-email">
        <div class="email-input">
          <label>
            Enviar para o e-mail <span>*</span>
          </label>
          <input v-model="valueEmail" type="text" placeholder="Digite o seu E-mail">
          <span v-if="validateInputEmail" class="validate-input">
            Parece que esse é um e-mail inválido, digite outro e-mail e tente novamente.
          </span>
        </div>
        <div class="email-btn">
          <span @click="statusEmail(false)" class="btn-cancel">Cancelar</span>
          <button @click="sendEmail()" class="btn-send" :disabled="loadingEmail">
            <div v-if="loadingEmail" class="loading-btn">
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5">
                </div>
              </div>
            </div>
            <div v-else class="btn-group">
              Enviar
            </div>
          </button>
        </div>
      </div> -->

      <!-- <button v-else @click="statusEmail(true)">
        <ion-icon name="mail-outline"></ion-icon>
        Enviar por e-mail
      </button> -->

      <button @click="closeModal">
        Fechar
      </button>
    </confirmation-modal>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import buttonBack from "../../components/buttonBack";
  import loadingPage from "../../components/loadingPage";
  import modalDisapproved from "../../components/modalDisapproved";
  import moment from 'moment'
  import swal from 'sweetalert';

  import {
    POINT_DETAIL,
    SHARE_INFO,
    PAUSES_FROM_DAY,
    ADN_DENIED_MOTIVE,
    GET_POINT_VOUCHER,
    JUSTIFY_HE, DOWNLOAD_VAUCHER
  } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import ModalPointVaucher from "../../modals/modalPointVaucher";
  import vueFooter from "../../components/footer.vue";
  import confirmationModal from '../../components/confirmationModal.vue';
  import ModalSolicitation from "../../modals/modalSolicitation.vue";

  let authUser = JSON.parse(window.localStorage.getItem('authUser'));
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));

  export default {
    name: 'detail-point',
    components: {
      ModalSolicitation,
      vueFooter,
      ModalPointVaucher,
      leftMenu,
      buttonBack,
      loadingPage,
      modalDisapproved,
      confirmationModal
    },
    data() {
      return {
        loadDataModal: false,
        isVoucherModalOpened: false,
        // progressPercent: null,
        isModalErrorOpened: false,
        contentJustify: '',
        loadingJustify: false,
        validateContentJustify: false,
        showJustify: false,
        needException: false,
        newPointRegister: 0,
        loadingPauseDetail: false,
        loadingMotive: false,
        loadingPauses: false,
        loadingRequest: false,
        pointId: this.$route.params.idPoint,
        showTimelinePause: JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause,
        todayIs: moment().format("DD/MM/YYYY"),
        dataInfo: {
          listPoint: [],
          justify: '',
        },
        dataModal: '',
        dataPause: {
          pauses: []
        },
        routeBack: '',
        loadingVaucher: false,
        dataCodeVaucher: '',
        openedVaucher: true,
        downloadVaucher: false,
      }
    },
    methods: {
      openModalSolicitation() {
        this.loadDataModal = true;
        $('#infoSolicitation').modal();
      },
      closeModal() {
        this.isModalErrorOpened = false;
        this.isVoucherModalOpened = false;
        // $('#modalPointVaucher').modal('hide');
      },
      justifyHe() {
        this.loadingJustify = true;
        this.validateContentJustify = false;

        const obj = {
          id: this.pointId,
          motive: '',
        }

        if (this.contentJustify === '' || this.contentJustify.length <= 4) {
          this.loadingJustify = false;
          return this.validateContentJustify = true;
        } else {
          obj.motive = this.contentJustify;
        }

        REQUEST_SERVICE.post(JUSTIFY_HE, obj).then((response) => {
          this.loadingJustify = false;
          swal("Sucesso!", response.data, "success");
          this.dataInfo.hasJustify = true;
          this.dataInfo.justify = this.contentJustify;

        }).catch(reason => {
          swal("Aviso", reason.data, "error");
          this.loadingJustify = false;
        });
      },
      openMotive() {
        this.loadingMotive = true;
        REQUEST_SERVICE.get(ADN_DENIED_MOTIVE + this.$route.params.idPoint).then((response) => {
          this.loadingMotive = false;
          swal("Motivo", response.data, "info");
        }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'openMotive', {idPoint: this.$route.params.idPoint}, true, reason.response.data);
          this.loadingMotive = false;
        });
      },
      openModalVaucher() {
        this.loadingVaucher = true;

        if(this.downloadVaucher) {
          let urlVaucher = DOWNLOAD_VAUCHER + this.$route.params.idPoint

          this.loadingVaucher = true;

          UTIL_SERVICE.console("url send:", urlVaucher);
          REQUEST_SERVICE.get(urlVaucher).then((response) => {

            UTIL_SERVICE.console("RESULT DOWNLOAD_VAUCHER", response.data);

            window.open(response.data, "_blank")
            this.loadingVaucher = false;
          }).catch(reason => {
            this.loadingVaucher = false;

            this.isModalErrorOpened = true;


            reason.response.data.erros.map((value, index) => {
              // swal("Aviso", value.value, "error");
              this.isModalErrorOpened = true;
            });
          });

        } else {
          if (this.openedVaucher) {
            let url = GET_POINT_VOUCHER + `${this.pointId}`;
            if (this.newPointRegister) {
              url += `?totalPoints=${this.newPointRegister}`;
            }

            REQUEST_SERVICE.get(url)
              .then((response) => {
                UTIL_SERVICE.console("RESULT GET_POINT_VOUCHER:", response.data);
                this.isVoucherModalOpened = true;
                this.loadingVaucher = false;

                this.dataCodeVaucher = response.data

                this.openedVaucher = true;
              }).catch(reason => {
              this.loadingVaucher = false;
              this.isModalErrorOpened = true;
              this.openedVaucher = true;
              UTIL_SERVICE.console("RESULT ERROR:", reason);
            });
          } else {
            this.loadingVaucher = false;
            this.isModalErrorOpened = true;
            this.openedVaucher = true;
          }
        }
      },
      getDetail() {
        this.loadingRequest = true;

        REQUEST_SERVICE.get(POINT_DETAIL + this.$route.params.idPoint).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_DETAIL:", response.data);
          this.loadingRequest = false;

          response.data.convertDate = moment(response.data.date).format("DD/MM/YYYY");
          response.data.showAdj = response.data.convertDate !== this.todayIs;
          this.dataInfo = response.data;
          
          if (this.dataInfo.progressPercent) {
            setTimeout(()=>{
              // this.progressPercent = this.dataInfo.progressPercent/100 * 180;
              let deg = this.dataInfo.progressPercent/100 * 180;
              
              if (deg >= 180) deg = 180;
              document.getElementById("maskFull").style.transform = "rotate(" + deg + "deg)";
              document.getElementById("firstFill").style.transform = "rotate(" + deg + "deg)";
              document.getElementById("secondFill").style.transform = "rotate(" + deg + "deg)";
              document.documentElement.style.setProperty('--transformEnd',deg + "deg");
            },500);
          }
          
          if (this.showTimelinePause) {
            this.getDataPause();
          }
        }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'getDetail', this.$route.params.idPoint, true, reason.response.data);
          this.loadingRequest = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        }).finally(() => {
          this.loadingRequest = false;
        });
      },

      //Old
      openModalDisapproved() {
        this.dataModal = this.pointId;

        $('#modalDisapproved').modal('toggle');
      },
      sendReceipt() {
        swal("Aviso", "Deseja enviar o comprovante por email?", {
          buttons: {
            cancel: "Cancelar",
            catch: {
              text: "Enviar",
              value: "send",
            }
          },
        })
          .then((value) => {
            switch (value) {
              case "send":
                let url = SHARE_INFO + this.$route.params.idPoint;
                try {
                  let browserInfo = UTIL_SERVICE.checkBrowser();
                  url += "?deviceModel=" + browserInfo.name;
                  url += "&deviceId=" + JSON.parse(window.localStorage.getItem('browserId'));
                } catch(err) { }

                UTIL_SERVICE.console("url send:", url);
                REQUEST_SERVICE.get(url).then((response) => {
                  swal("Sucesso!", response.data, "success");
                  UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendReceipt', null, false, null);
                }).catch(reason => {
                  UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendReceipt', {idPoint: this.$route.params.idPoint}, true, reason.response.data);

                  this.loadingRequest = false;
                  // Show errors.
                  reason.response.data.erros.map((value, index) => {
                    swal("Aviso", value.value, "error");
                  });
                });
                break;
            }
          });
      },
      getDataPause() {
        this.loadingPauses = true;
        let url = PAUSES_FROM_DAY;
        url += "?u=" + userInfo.id;
        url += "&reference=" + this.dataInfo.reference;

        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT PAUSES_FROM_DAY:", response.data);

          this.dataPause = response.data;
          this.loadingPauses = false;
        }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'getDataPause', {reference: this.dataInfo.reference}, true, reason.response);
          this.loadingPauses = false;
        });
      }
    },
    beforeMount() {

      let dataUserInfo = UTIL_SERVICE.getStorage('userInfo');

      try {
        let localCompany = JSON.parse(window.localStorage.getItem('userInfo')).company;
        this.downloadVaucher = localCompany.receipt
      } catch (e) {}

      try {
        const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
        if (dataConfigProgressPoint.newPointRegister) {
          this.newPointRegister = dataConfigProgressPoint.newPointRegister;
        }

        if(dataUserInfo.company.sporadic) {
          this.needException = dataUserInfo.company.sporadic
        }

      } catch (e) {}

      moment.locale('pt-br');

      if (this.$route.params.type === '2') {
        this.routeBack = "/historico-de-ocorrencia";
      } else if (this.$route.params.type === '6') {
        this.routeBack = "/minhas-solicitacoes";
      } else if (this.$route.params.type === '5') {
        this.routeBack = "/";
      } else {
        this.routeBack = "/historico-de-ponto";
      }
      
      this.getDetail();
    },
  }
</script>

<!-- Style from page -->
<style lang="scss">
#voucher-modal {

  .body-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin-top: 0;
    border-top: none;
    border-bottom: 1px dashed #191919;
    height: auto;

    ion-icon {
      width: 82px;
      height: 82px;
    }
  }

  button {
    border-radius: 20px;
    border: 1px solid var(--darkBlue);
    background: var(--darkBlue);
    display: inline-flex;
    justify-content: center;
    width: 97px;
    height: 34px;
    padding: 8px 12px;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    color: #fff;
    font-weight: 600;

    ion-icon {
      width: 18px;
      height: 18px;
      color: #fff
    }
  }
}


.voucher-modal-body {
  padding: 16px;
  background: #FFF0B4;
  position: relative;
  width: 327px;
  margin-bottom: 23px;

  .footer-body {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    border-top: 1px solid #FFF0B4;

    svg {
      path {
        fill: #FFF0B4;
        opacity: 1;
      }
    }
  }
  .body-signature {
    display: flex;
    flex-direction: column;
    word-break: break-all;

    .signature-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 14.06px;
      color: #191919;
    }

    .signature-id {
      font-size: 10px;
      font-weight: 400;
      line-height: 14.06px;
      color: #191919;
      margin-bottom: 8px;

      .more-less {
        color: var(--textActiveSide);
        cursor: pointer;
        font-size: 10px;
        font-weight: 400;
        line-height: 14.06px;
        margin: 0 0 0 6px;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .signature-reference {
      font-size: 14px;
      font-weight: 400;
      line-height: 19.69px;
      color: #191919;

      span {
        font-size: 14px;
        font-weight: 700;
      }
    }
  }

  .voucher-header {
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 16px;
    font-weight: 400;
    color: #191919;
    text-align: center;

    .header-date {
      font-weight: 700;
    }

    span:nth-child(2) {
      font-weight: 600;
    }

    span {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      color: #191919 !important;
      p {
        font-weight: 600;
        margin: 0!important;
      }
    }
  }

  .body-content {
    margin-top: 26px;
    padding-top: 9px;
    border-top: 1px dashed #191919;
    border-bottom: 1px dashed #191919;
    margin-bottom: 18px;
    overflow: auto;
    height: 101px;
    gap: 5px;

    ion-icon {
      width: 82px;
      height: 82px;
    }


    &::-webkit-scrollbar {
      width: 6px;
      position: absolute;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #D5DFEB;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #3A424E;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #3A424E;
      transition: .5s;
    }

    .content-points {
      display: flex;
      flex-direction: column;
      word-break: break-all;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 18px;
      }

      .point-title {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.69px;

        span {
          font-size: 14px;
          font-weight: 700;
        }
      }

      .point-code {
        display: flex;

        span {
          margin-left: 3px;
        }

        .more-less {
          color: var(--textActiveSide);
          cursor: pointer;
          font-size: 10px;
          font-weight: 400;
          line-height: 14.06px;
          margin: 0;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      span {
        color: #191919;
        font-size: 10px;
        font-weight: 400;
        line-height: 14.06px;
      }
    }
  }

  .body-collaborator {
    display: flex;
    flex-direction: column;
    word-break: break-all;
    border-bottom: 1px dashed #191919;
    margin-bottom: 10px;
    padding-bottom: 18px;

    .collaborator-name {
      font-size: 14px;
      font-weight: 400;
      line-height: 19.69px;
      color: #191919 !important;

      span {
        font-size: 14px;
        font-weight: 700;
      }
    }

    span {
      font-weight: 700;
      font-size: 14px;
    }
  }

}

.box-justify-he {
  background: var(--bodyContrast) 0 0 no-repeat padding-box;
  box-shadow: 0 0 15px #0000000d;
  border-radius: 12px;
  border: none;
  text-align: inherit;
  padding-top: 12px;
  padding-bottom: 24px;

  .title-justify {
    display: block;
    margin-bottom: 15px;
  }

  div {
    span {
      color: var(--titleBox);
      font-size: 22px;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--bodyColor);
      font-weight: 400;
    }

    b {
      font-size: 14px;
      font-weight: 400;
      color: var(--linkColor);
      margin-top: 20px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .validate-justify {
    font-size: 11px;
    color: var(--redColor);
    position: absolute;
    left: 15px;
    bottom: 45px;
    border: none;
  }

  span {
    font-size: 15px;
    font-weight: 500;
  }

  textarea {
    margin-top: 15px;
    max-width: 100%;
    min-width: 100%;
    min-height: 30px;
    max-height: 150px;
    border: 1px solid var(--bodyColor);
    background: #ffffff !important;
  }

  button {
    background: #2ACC6B;
    padding: 4px 20px;
    border-radius: 4px;
    border: none;
    margin-top: 15px;
    float: right;
    transition: .2s;

    &:hover {
      background: #08A747;
    }

    span {
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
    }

    .spinner-btn {
      height: 22px;

      > div {
        padding-top: 0;
        margin-right: 2.5px;
      }
    }
  }

  .justified-he {
    text-align: initial;
    padding-top: 6px;

    span {
      font-size: 22px;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--bodyColor);
      display: block;
    }

    p {
      margin-top: 15px;
      font-weight: 700;
    }
  }
}

.box-justified {
  background: var(--bodyContrast) 0 0 no-repeat padding-box;
  box-shadow: 0 0 15px #0000000d;
  border-radius: 12px;
  border: none;
  text-align: inherit;
  cursor: inherit;

  &:hover {
    background: var(--bodyContrast) 0 0 no-repeat padding-box;
  }

  div {
    padding-top: 10px;

    span {
      color: var(--titleBox);
      font-size: 22px;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--bodyColor);
      font-weight: 400;
    }

    p {
      margin-top: 20px;
      color: var(--titleBox);
      font-weight: 700;
    }
  }
}

.vaucher-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  margin: 18px auto auto auto;
  background: none;
  border: none;

  .vaucher-point {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: var(--linkColor);
    cursor: pointer;

    svg {
      path {
        fill: var(--linkColor);;
      }
      margin-right: 8px;
    }
  }

  .loading-btn {
    cursor: no-drop;

    .rect1, .rect2, .rect3, .rect4, .rect5 {
      background: var(--linkColor);
    }
  }
}

.custom-scrollbar {
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #9c9797;
    border: 0 solid #9c9797;
  }
}

.pause-timeline {
  h3 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 20px;
  }

  .content {
    overflow: auto;
    height: 270px;
    margin-bottom: 60px;

    .border-exit {
      border-left: #e81212 2px solid;
    }

    .border-entry {
      border-left: #0f77ae 2px solid;
    }

    .pause-list-item {
      background: #eeeeee;
      padding: 10px;
      margin-bottom: 4px;
      overflow: hidden;

      .item-title {
        p {
          font-size: 15px;
          color: #2b4a5c;
          margin: 0;
          padding-top: 3px;
          padding-bottom: 13px;
          span {
            font-weight: 600;
          }
        }
      }

      .item-text {
        font-size: 13px;
        color: #2b4a5c;
        padding-bottom: 5px;
      }

      .item-controls {
        margin-top: 5px;
        float: left;

        .list-date {
          color: #2b4a5c;
          margin-right: 12px;

          i {
            color: #2b4a5c;
            margin-right: 5px;
          }
        }

        .badge {
          font-size: 12px;
          font-weight: 300;
          color: #fff;
          padding: 4px 6px 4px 6px;
          text-align: center;
          border-radius: 2px;
          background: #de5f05;
        }

        .badge-success {
          font-size: 12px;
          font-weight: 300;
          color: #fff;
          padding: 4px 6px 4px 6px;
          text-align: center;
          border-radius: 2px;
          background: #00a651;
        }
      }

      &:hover {
        background-color: #f2f2f2;
      }
    }
  }

}

.text-motive {
  color: #f00000 !important;
  border-bottom: 1px solid #f00;
  cursor: pointer;
  i {
    margin-left: 5px;
  }
}

.default {
  border: 1px solid #ccc;
  color: #ccc;
}

.done {
  border: 1px solid #008141;
  color: #008141;
}

.fault {
  border: 1px solid #e74a4e;
  color: #e74a4e;
}

.incorrect {
  border: 1px solid #e86800;
  color: #e86800;
}

.working {
  border: 1px solid #6897bb;
  color: #6897bb;
}

.out {
  border: 1px solid #a3a3a3;
  color: #a3a3a3;
}

.box-alert {
  background: #e86800;
  padding: 15px 10px;
  margin: 0 0 20px 0;
  border-radius: 4px;

  p {
    margin-left: 20px;
    display: inline-block;
    font-size: 18px;
    color: #fff;

    a {
      color: #fff;
      border-bottom: 1px solid #fff;

      &:hover {
        text-decoration: none;
      }
    }
  }

  i {
    margin-left: 10px;
    display: inline-block;
    color: #fff;
    font-size: 40px;
    position: absolute;
    left: 0;
  }
}

.box-detail-point {
  .title {
    color: #373737;
    margin-top: 30px;
    letter-spacing: 1px;
  }

  .detail {
    padding: 0;
    margin-top: 10px;

    .day {
      p {
        color: #373737;
        font-size: 18px;
        margin: 10px 0 0 0;

        &:last-child {
          margin-top: 5px;
          font-weight: bold;
        }
      }
    }

    .info {
      padding: 0;
      margin-top: 30px;

      div {
        p {
          display: inline-block;
          float: left;
          font-size: 16px;
          color: #373737;
          font-weight: bold;

          &:last-child {
            float: right;
            font-weight: normal;
          }
        }
      }
    }

    .record-day {
      margin-top: 30px;
      margin-bottom: 40px;
      padding: 0;

      h4 {
        color: #0F77AE;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
      }

      div {
        span {
          display: inline-block;
          float: left;
          font-size: 16px;
          color: #373737;
          font-weight: bold;
        }
        p {
          display: inline-block;
          float: left;
          font-size: 16px;
          color: #373737;
          font-weight: bold;

          &:last-child {
            float: right;
            font-weight: normal;
          }
        }
      }

    }
  }

  .info-day {
    p {
      color: #0F77AE;
      margin-top: 5px;
      font-size: 20px;
    }
  }

  .user-progress {

    .status {
      float: right;
      margin-bottom: 10px;
      padding: 0;

      p {
        text-align: center;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        padding: 7px 10px;
      }
    }

    .progress-info {
      border: 1px solid #373737;
      padding: 10px 20px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;

      span {
        color: #373737;
        font-size: 16px;
      }

      div {
        height: 3px;
        width: 100%;
        background: #a39f9f;
        -webkit-border-radius: 100px;
        -moz-border-radius: 100px;
        border-radius: 100px;
        margin: 15px 0 10px 0;

        div {
          background: #0F77AE;
        }
      }

      p {
        color: #373737;
        display: inline-block;
        font-size: 16px;
        margin-top: 10px;

        &:first-child {
          float: left;
        }

        &:last-child {
          float: right;
        }
      }
    }

    .receipt {
      border: 1px solid #5EACD5;
      color: #5EACD5;
      cursor: pointer;
      float: right;
      text-align: center;
      margin-top: 20px;
      border-radius: 4px !important;
      padding: 0 10px;

      i {
        display: inline-block;
        margin-left: 5px;
        padding: 10px 0 10px 3px;

      }

      span {
        padding: 10px 5px;
      }

      @media only screen and (max-device-width: 414px) {
        margin-bottom: 0;
      }
    }

    .adjust {
      border: 1px solid #5EACD5;
      color: #5EACD5;
      cursor: pointer;
      float: right;
      text-align: center;
      margin-top: 20px;
      border-radius: 4px !important;
      padding: 0 10px;
      margin-right: 20px;

      i {
        display: inline-block;
        margin-left: 5px;
        padding: 10px 0 10px 3px;

      }

      span {
        padding: 10px 5px;
      }

      @media only screen and (max-device-width: 414px) {
        margin-top: 20px;
      }
    }

    .adjustment {
      text-align: left;
      margin-bottom: 20px;

      img {
        display: inline-block;
        width: 60px;
        height: 60px;
      }
      p {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        color: #00A651;
      }
    }

    .adj-sol {
      text-align: left;
      margin-bottom: 20px;

      img {
        display: inline-block;
        width: 50px;
        height: 50px;
      }

      p {
        display: inline-block;
        font-size: 14px;
        font-weight: 600;
        color: #c29d0b;
      }
    }
  }
}

.limit-history {
  max-height: 210px !important;
}

.box-exception {
  padding: 15px !important;
  display: flex;
  flex-direction: column;

  &-title {
    color: #908CB2;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140.625%;
  }

  &-motive {
    margin-top: 5px;
    color: #848C9B;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 140.625%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/detailPoint/DetailPoint.vue